module.exports = __webpack_public_path__ + "img/token-null.0a99737e.png";